import get from 'lodash/get';
import _ from 'lodash';
import moment from 'moment-timezone';
import { getItemErrors } from './DishUtils';
import { DeliveryTypes } from './constants';

export function isItemAvailable(itemId, itemsHash) {
  return !getUnavailableItemsInNestedItem(itemId, itemsHash).length > 0;
}

export function getUnavailableItemsInNestedItem(itemId, itemsHash) {
  const items = getAllNestedItems(itemId, itemsHash);
  const unavailable = [];
  items.forEach(id => {
    if (getItemErrors(itemsHash[id], moment()).length > 0) {
      unavailable.push(id);
    }
  });
  return unavailable;
}

export function getPriceByItemId(item, itemsHash) {
  const itemFromMenu = itemsHash[item.itemId];
  return itemFromMenu ? itemFromMenu.price : item.price;
}

export function convertToTree({ simplifiedMenu, locale, deliveryType, timezone }) {
  const simplifiedMenus = get(simplifiedMenu, 'simplifiedMenus', []);

  return simplifiedMenus.reduce((acc, menuItem) => {
    const title = menuItem.title[locale];
    const children = get(menuItem, 'sections', []).reduce((acc2, section) => {
      const sectionTitle = section.title[locale];

      const hasChildren = section.itemIds.some(itemId => {
        const item = simplifiedMenu.simplifiedItems.find(i => i.id === itemId);
        return isVisible(item, deliveryType);
      });

      if (isVisible(section, deliveryType, timezone, simplifiedMenu.modified) && hasChildren) {
        acc2[section.id] = { label: sectionTitle, id: section.id };
      }
      return acc2;
    }, {});

    if (isVisible(menuItem, deliveryType, timezone, simplifiedMenu.modified) && !_.isEmpty(children)) {
      acc[menuItem.id] = {
        label: title,
        children,
        id: menuItem.id,
      };
    }
    return acc;
  }, {});
}

export function isMenuEmpty({ simplifiedMenu, locale, timezone }) {
  return (
    _.isEmpty(convertToTree({ simplifiedMenu, locale, deliveryType: DeliveryTypes.DELIVERY, timezone })) &&
    _.isEmpty(convertToTree({ simplifiedMenu, locale, deliveryType: DeliveryTypes.TAKEOUT, timezone }))
  );
}

export function getKey(title) {
  return title.toLowerCase().replace(/\s/g, '_');
}

export function getAllNestedItems(itemId, itemsHash) {
  //todo masha check for loops?

  const items = new Set();
  items.add(itemId);
  const variations = [];
  (itemsHash[itemId].variations || []).forEach(variation => {
    variations.push(...variation.itemIds.map(item => item.itemId));
  });
  while (variations.length > 0) {
    const item = variations.pop();
    if (!items.has(item)) {
      items.add(item);
      itemsHash[itemId].variations.forEach(variation => {
        variations.push(...variation.itemIds.map(nestedItem => nestedItem.itemId));
      });
    }
  }
  return Array.from(items);
}

function getAllDeletedItems(menu) {
  if (!menu.sections) {
    return [];
  }
  const trash = menu.sections.find(section => section.id === 'trash');
  return trash && trash.itemIds ? trash.itemIds : [];
}

export function isItemDeletedFromMenu(itemId, menu) {
  return getAllDeletedItems(menu).includes(itemId);
}

export function isVisible(item) {
  let visible = true;

  if (item && item.condition) {
    const condition = item.condition;

    visible = visible && !condition.disabled;
    visible = visible && condition.platforms['callcenter'];
  }

  return visible;
}

export function getSimplifiedSectionByItemId(simplifiedMenu, itemId) {
  for (let i = 0; i < simplifiedMenu.simplifiedMenus.length; i++) {
    const menu = simplifiedMenu.simplifiedMenus[i];
    for (let j = 0; j < menu.sections.length; j++) {
      const child = menu.sections[j];
      if (child.itemIds.includes(itemId)) {
        return _.cloneDeep(child);
      }
    }
  }
}

export function getSimplifiedMenuByItemId(simplifiedMenu, itemId) {
  for (let i = 0; i < simplifiedMenu.simplifiedMenus.length; i++) {
    const menu = simplifiedMenu.simplifiedMenus[i];
    for (let j = 0; j < menu.sections.length; j++) {
      const child = menu.sections[j];
      if (child.itemIds.includes(itemId)) {
        return _.cloneDeep(menu);
      }
    }
  }
}

export function getSectionByItemId(menu, itemId) {
  for (let i = 0; i < menu.sections.length; i++) {
    const section = menu.sections[i];
    const children = section.children || [];
    for (let j = 0; j < children.length; j++) {
      const child = children[j];
      const itemIds = child.itemIds || [];
      if (itemIds.includes(itemId)) {
        return _.cloneDeep(child);
      }
    }
  }
}

export function getMenuByItemId(menu, itemId) {
  for (let i = 0; i < menu.sections.length; i++) {
    const section = menu.sections[i];
    const children = section.children || [];
    for (let j = 0; j < children.length; j++) {
      const child = children[j];
      const itemIds = child.itemIds || [];
      if (itemIds.includes(itemId)) {
        return _.cloneDeep(section);
      }
    }
  }
}
